import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Angular Material
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

// Existing blocks components
import { BlockTitleComponent } from '../components/block-title/block-title.component';

// Local components and services
import { UpgradeLogsViewerComponent } from './upgrade-logs-viewer.component';
import { ComponentsModule } from './components/components.module';
import { UpgradeLogsViewerService } from './services/upgrade-logs-viewer.service';
import { UpgradeLogsFilterService } from './services/upgrade-logs-filter.service';

@NgModule({
  declarations: [
    UpgradeLogsViewerComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    // Angular Material
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatChipsModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatMenuModule,
    MatTabsModule,
    MatProgressBarModule,
    MatExpansionModule,
    MatProgressSpinnerModule,

    // Existing blocks components
    BlockTitleComponent,

    // Local components
    ComponentsModule
  ],
  providers: [
    UpgradeLogsViewerService,
    UpgradeLogsFilterService
  ],
  exports: [
    UpgradeLogsViewerComponent
  ]
})
export class UpgradeLogsViewerModule { }